import root from 'react-shadow';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import type { SxProps, Theme } from '@mui/material/styles';

interface HtmlPreviewProps {
  html: string;
  width?: number | string;
  height?: number | string;
  minHeight?: number;
  title?: string;
  showTitle?: boolean;
  customStyles?: string;
  sx?: SxProps<Theme>;
}

export default function HtmlPreview({
  html,
  width,
  height,
  minHeight,
  title,
  showTitle = true,
  customStyles,
  sx,
}: HtmlPreviewProps) {
  return (
    // need to isolate html styling from gwt's css overrides, can likely be removed in v2.5
    <Card
      sx={[
        {
          minHeight: minHeight ? minHeight : 275,
          width: width ? width : '100%',
          height: height ? height : 'auto',
        },
        ...(Array.isArray(sx) ? sx : [sx ? sx : []]),
      ]}
    >
      <CardContent>
        {showTitle && (
          <Typography sx={{ fontWeight: 'light', mb: 1 }}>
            {title ? title : 'Preview:'}
          </Typography>
        )}
        <root.div>
          {customStyles && <style>{customStyles || ''}</style>}
          <div
            dangerouslySetInnerHTML={{
              __html: html,
            }}
          ></div>
        </root.div>
      </CardContent>
    </Card>
  );
}
